
/**
 * @nullable
 */
export type SendNotificationRequestMetadata = {[key: string]: string} | null;
